import { Client } from './version';

/**
 * Configuration values set by the webpack.DefinePlugin
 * to be injected into the codebase.
 */
declare const __SLACK_TRELLO_DOMAIN__: string;
declare const __SLACK_DOMAIN__: string;
declare const __TRELLO_FOR_WEBSITES__: string;
declare const __CUSTOM_FIELDS_ID__: string;
declare const __FIRST_PARTY_PLUGINS_ORG__: string;
declare const __LIST_LIMITS_POWERUP_ID__: string;
declare const __MAP_POWERUP_ID__: string;
declare const __BITBUCKET_POWERUP_ID__: string;
declare const __ATTACHMENTS_DOMAIN__: string;
declare const __AVATAR_DOMAIN__: string;
declare const __BACKGROUND_DOMAIN__: string;
declare const __LOGO_DOMAIN__: string;
declare const __ONE_DRIVE_CLIENT_ID__: string;
declare const __GOOGLE_DRIVE_CLIENT_ID__: string;
declare const __DROPBOX_CLIENT_APP_KEY__: string;
declare const __BOX_CLIENT_ID__: string;
declare const __BRAINTREE_CLIENT_TOKEN__: string;
declare const __GOOGLE_MAPS_API_KEY__: string;
declare const __SNOWPLOW_CLOUDFRONT_SERVER__: string;
declare const __ANALYTICS_WEB_CLIENT_ENV__: string;
declare const __LAUNCH_DARKLY_KEY__: string;
declare const __APPCUES_ACCOUNT_ID__: string;
declare const __TRELLO_VERSION__: string;
declare const __AA_MANAGED_PROFILE_URL__: string;
declare const __AA_MANAGE_RECENT_DEVICES_URL__: string;
declare const __ATLASSIAN_API_GATEWAY__: string;

export const slackTrelloDomain: string = __SLACK_TRELLO_DOMAIN__;
export const slackDomain: string = __SLACK_DOMAIN__;
export const trelloForWebsites: string = __TRELLO_FOR_WEBSITES__;
export const customFieldsId: string = __CUSTOM_FIELDS_ID__;
export const firstPartyPluginsOrg: string = __FIRST_PARTY_PLUGINS_ORG__;
export const listLimitsPowerUpId: string = __LIST_LIMITS_POWERUP_ID__;
export const mapPowerUpId: string = __MAP_POWERUP_ID__;
export const bitbucketPowerUpId: string = __BITBUCKET_POWERUP_ID__;
export const attachmentsDomain: string = __ATTACHMENTS_DOMAIN__;
export const avatarDomain: string = __AVATAR_DOMAIN__;
export const backgroundDomain: string = __BACKGROUND_DOMAIN__;
export const logoDomain: string = __LOGO_DOMAIN__;
export const oneDriveClientId: string = __ONE_DRIVE_CLIENT_ID__;
export const googleDriveClientId: string = __GOOGLE_DRIVE_CLIENT_ID__;
export const dropboxClientAppKey: string = __DROPBOX_CLIENT_APP_KEY__;
export const boxClientId: string = __BOX_CLIENT_ID__;
export const braintreeClientToken: string = __BRAINTREE_CLIENT_TOKEN__;
export const googleMapsApiKey: string = __GOOGLE_MAPS_API_KEY__;
export const snowplowCloudfrontServer: string = __SNOWPLOW_CLOUDFRONT_SERVER__;
export const analyticsWebClientEnv: string = __ANALYTICS_WEB_CLIENT_ENV__;
export const launchdarklyKey: string = __LAUNCH_DARKLY_KEY__;
export const appcuesAccountId: string = __APPCUES_ACCOUNT_ID__;
export const aaManagedProfileUrl: string = __AA_MANAGED_PROFILE_URL__;
export const aaManageRecentDevicesUrl: string = __AA_MANAGE_RECENT_DEVICES_URL__;
export const atlassianApiGateway: string = __ATLASSIAN_API_GATEWAY__;

/**
 * Current build version information
 */
const trelloVersion: string = __TRELLO_VERSION__;
export const client = new Client(trelloVersion);
export const clientVersion: string = client.toString();

/**
 * Locale value is set in all the localized html templates,
 * so needs to be read from the window
 */
export const locale: string = window.locale || 'en';

/**
 * Reference to runtime site origin
 */
export const siteDomain: string =
  location.origin || /^[^/]+?[/]{2}[^/]+/.exec(location.href)![0];
